<template lang="pug">
.family-detail-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc hide-footer)
    template(#modal-header="{ cancel }")
      .d-flex.flex-row.flex-row-reverse(v-if="allDeleteButton == true" style="width:100%;")
        button.btn(@click="onAllDelete" style="width: 98px;") 全員削除
      button.close(type="button" @click="cancel") ×
  
    .family-detail-modal-table
      .thead
        .header-line
          .th.sender-type 送信手段
          .th.name 家族ユーザー名
          .th.relation 続柄
          .th.position 役割
          .th.reply-message-function(v-if="hideFunctions == false") 家族からの連絡
          .th.picture-function(v-if="hideFunctions == false") 写真印刷依頼
          .th.tel 電話番号
          .th.operation 登録情報
          .th.send-message 登録確認
      .tbody
        .body-line(v-for="family in families")
          // 送信手段
          .td.sender-type.center {{ getSenderType(family.senderType) }}
          // 家族ユーザー名
          .td.name
            div {{ family.familyName }}
          // 続柄
          .td.relation {{ family.familyRelation }}
          // 役割
          .td.position(v-if="family.familyPosition")
            div {{ family.familyPosition }}
          .td.position(v-else) 未設定
          // 家族からの連絡
          template(v-if="family.senderType == 1 && hideFunctions == false")
            .td.reply-message-function －
          template(v-else-if="hideFunctions == false")
            .td.reply-message-function.used(v-if="family.familyPermittedFunctions.opinion") 使用可
            .td.reply-message-function.unused(v-else) 使用不可
          // 写真印刷依頼
          template(v-if="family.senderType == 1 && hideFunctions == false")
            .td.picture-function －
          template(v-else-if="hideFunctions == false")
            .td.picture-function.used(v-if="family.familyPermittedFunctions.picture") 使用可
            .td.picture-function.unused(v-else) 使用不可
          // 電話番号
          .td.tel {{ family.familyTel }}
          // 登録情報
          .td.operation.d-flex.justify-content-center
            .control-buttons.d-flex.justify-content-center(v-if="family.senderType == 0")
              button.btn.edit-btn.mr-2(@click="onEdit(family)" type="button") 修正
              button.btn.delete-btn(@click="onLineDelete(family)" type="button") 削除
            .control-buttons.d-flex.justify-content-center(v-if="family.senderType == 1")
              button.btn.edit-btn.mr-2(@click="onEdit(family)" type="button") 修正
              button.btn.delete-btn(@click="onMailDelete(family)" type="button") 削除
          // 登録確認
          .td.send-message.d-flex.justify-content-center
            button.btn.testmail-btn(v-if="family.senderType == 1" @click="onSendMessage(family)" type="button") 確認送信
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SenderType } from "@/commons/models/Resident";
import { FamilyGetModel } from "@/commons/services/Families";

/**
 * 家族詳細表示モーダル
 */
@Component
export default class FamilyDetailModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /**
   * 家族
   */
  @Prop({
    default: () => {
      return [];
    }
  })
  families!: Array<FamilyGetModel>;

  @Prop({ default: false })
  hideFunctions!: boolean;

  @Prop({ default: false })
  allDeleteButton!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### 送信種別を返す
   */
  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.LINE) {
      return "LINE";
    } else if (senderType == SenderType.MAIL) {
      return "メール";
    } else {
      return "";
    }
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(family: FamilyGetModel): void {
    this.$emit("onEdit", family);
    return;
  }

  /**
   * ### LINEユーザー削除ボタン押下イベント
   */
  public onLineDelete(family: FamilyGetModel): void {
    this.$emit("onLineDelete", family);
    return;
  }

  /**
   * ### MAILユーザー削除ボタン押下イベント
   */
  public onMailDelete(family: FamilyGetModel): void {
    this.$emit("onMailDelete", family);
    return;
  }

  /**
   * ### 確認送信ボタン押下イベント
   */
  public onSendMessage(family: FamilyGetModel): void {
    this.$emit("onSendMessage", family);
    return;
  }

  public onAllDelete(): void {
    this.$emit("onAllDelete");
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.used {
  color: $font-key-color;
  font-weight: bold;
}
.unused {
  color: $font-disable-font-color;
}

.edit-btn,
.delete-btn {
  width: 64px;
}

.testmail-btn {
  width: 100px;
}
</style>
